var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addon-product-container" }, [
    _c("div", { staticClass: "product-image-container available" }, [
      _vm.mainBadge != null
        ? _c("img", {
            staticClass: "main-badge",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/diverse.svg?v=1683569569"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.secondaryBadge != null && !_vm.isPride
        ? _c("span", { staticClass: "secondary-badge" }, [
            _vm._v(_vm._s(_vm.secondaryBadge))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isPride
        ? _c("img", {
            staticClass: "pride-badge",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/Pride_badge.svg?v=1717085583"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("img", {
        staticClass: "lazyload main-image",
        attrs: {
          src:
            "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
          width: "270",
          height: "270",
          "data-src": _vm._f("getProductImage")(_vm.product)
        }
      }),
      _vm._v(" "),
      _vm.product.images.length > 1
        ? _c("img", {
            staticClass: "hover-image",
            attrs: { src: _vm.product.images[1].src }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isBrandable
        ? _c("img", {
            staticClass: "logo-placeholder",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/logo_grey_2.svg?v=1725379927",
              alt: "logo here"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isBrandable
        ? _c("div", { staticClass: "edit-btn" }, [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634",
                alt: "edit"
              }
            })
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "happybox-button white border",
        attrs: {
          href:
            "/products/build-a-box?occasion=" +
            _vm.occasion +
            "&product=" +
            _vm.product.id
        }
      },
      [_vm._v("Add to Box")]
    ),
    _vm._v(" "),
    _c("p", { staticClass: "product-title" }, [
      _vm._v(_vm._s(_vm.product.title))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "product-price-container" }, [
      _vm.hasComparePrice != null
        ? _c("span", { staticClass: "discount-price" }, [
            _vm._v(_vm._s(_vm._f("moneySaleFormat")(_vm.hasComparePrice)))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "price" }, [
        _vm._v(_vm._s(_vm._f("moneySaleFormat")(_vm.productPrice)))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }